export default "__VITE_ASSET__fbceb762__"